import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

// Own constants/actions/components
import { resData } from 'services/selectors/filters';

const CardInfo = (props) => {
  const {
    inspire,
    recommend,
    stock,
    image,
    title,
    bodyText,
    place,
    points,
    pointsWithDisscount,
    textlabel,
  } = props;
  const baseClass = inspire ? 'card-info revive' : 'card-info';
  const dataFilter = useSelector(resData);
  const categories = dataFilter !== undefined ? dataFilter.results.categories : [];
  const getCategorie = categories.filter((categorie) => categorie.name === textlabel);

  return (
    <div className={baseClass}>
      <div className="header">
        <img
          src={image}
          alt="img-header" />
        <div className="label-card">
          { recommend
            ? (
              <span className="-icon" style={{ color: getCategorie[0].colorCode }}>
                <img src={getCategorie[0].icon} alt="icon-label" className="icon" />
                {textlabel}
              </span>
            ) : '' }
          {
            recommend && stock === 0 && (
              <div className="sold-out">
                <i className="fas fa-ban" />
                <span>AGOTADA</span>
              </div>
            )
          }
        </div>
      </div>
      { inspire
        ? (
          <div className="body-2 p-15">
            <h6 className="title">
              {title}
            </h6>
            <p className="text">{bodyText}</p>
          </div>
        ) : (
          <div className="body p-15">
            <h6 className="title">
              {title}
            </h6>
          </div>
        ) }
      { recommend
        ? (
          <div className="footer row p-15">
            <div className="col-6 pl-3 pr-0 location">
              <i className="fas fa-map-marker-alt" />
              <p title={place}>
                {place}
              </p>
            </div>
            <div className="col-6 pl-3 pr-0">
              {
                pointsWithDisscount > 0
                  ? (
                    <>
                      <del>{`${(Number(points)).toLocaleString('es-MX')} Puntos`}</del>
                      <p className="points">{`${(Number(pointsWithDisscount)).toLocaleString('es-MX')} Puntos`}</p>
                    </>
                  ) : <p className="points">{`${(Number(points)).toLocaleString('es-MX')} Puntos`}</p>
              }
            </div>
          </div>
        ) : '' }
    </div>
  );
};

CardInfo.defaultProps = {
  inspire: false,
  recommend: false,
  stock: null,
  image: '',
  title: '',
  bodyText: '',
  place: '',
  points: 0,
  pointsWithDisscount: 0,
  textlabel: '',
};

CardInfo.propTypes = {
  inspire: PropTypes.bool,
  recommend: PropTypes.bool,
  stock: PropTypes.number,
  image: PropTypes.string,
  title: PropTypes.string,
  bodyText: PropTypes.string,
  place: PropTypes.string,
  points: PropTypes.number,
  pointsWithDisscount: PropTypes.number,
  textlabel: PropTypes.string,
};

export default CardInfo;
